// Die Reiter unter dem Kopf: die Unterseiten eines Menüpunkts als eine Zeile aus Links.
// Welche Reiter zu welchem Pfad gehören, steht in bereiche.ts - keine Seite muss davon wissen.

import { NavLink } from 'react-router-dom'

export interface ReiterEintrag {
  pfad: string
  titel: string
  /** Kleine Marke am Reiter, z. B. offene Rückfragen. Nur sichtbar, wenn größer null. */
  zaehler?: number
  /** Nur genau dieser Pfad macht den Reiter aktiv - sonst auch alles darunter („/importe/3"). */
  ende?: boolean
}

interface Eigenschaften {
  eintraege: ReiterEintrag[]
}

export default function Reiter({ eintraege }: Eigenschaften) {
  return (
    <nav className="reiterzeile" aria-label="Unterseiten">
      {eintraege.map((e) => (
        <NavLink key={e.pfad} to={e.pfad} end={e.ende} className={({ isActive }) => `reiter${isActive ? ' aktiv' : ''}`}>
          {e.titel}
          {e.zaehler != null && e.zaehler > 0 && (
            <span className="zaehler" title={`${e.zaehler} offen`}>
              {e.zaehler}
            </span>
          )}
        </NavLink>
      ))}
    </nav>
  )
}
